<template>
  <!-- Goes inside an existing Bootstrap `.modal` wrapper (kiosk modals are still
       opened/closed through Bootstrap + jQuery by id). -->
  <div class="modal-dialog modal-dialog-centered ksk-modal-dialog" :style="{ '--ksk-modal-width': width + 'px' }">
    <div class="modal-content ksk-modal" v-bind="kskSlot('popup')">
      <div v-if="title || showClose" class="ksk-modal__header">
        <h2 v-if="title" class="ksk-modal__title">{{ title }}</h2>
        <button
          v-if="showClose"
          type="button"
          class="ksk-modal__close"
          :aria-label="$t('kiosk.common.close')"
          data-bs-dismiss="modal"
          @click="$emit('close')"
        >
          <span class="material-icons-round">close</span>
        </button>
      </div>
      <div class="ksk-modal__body">
        <slot />
      </div>
      <div v-if="$slots.footer" class="ksk-modal__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import { kskSlot } from "@/config/kioskColorSlots";

// KSK004 — centered kiosk modal shell, 480–960px wide, 32px radius.
// The scrim is the Bootstrap backdrop, recoloured in kiosk-theme2.css.
export default {
  name: "KskModalShell",
  emits: ["close"],
  props: {
    title: { type: String, default: "" },
    width: {
      type: Number,
      default: 760,
      validator: (v) => v >= 480 && v <= 960,
    },
    showClose: { type: Boolean, default: true },
  },
  methods: { kskSlot },
};
</script>

<style scoped>
.ksk-modal-dialog {
  max-width: var(--ksk-modal-width);
  width: var(--ksk-modal-width);
}
.ksk-modal {
  border: none;
  border-radius: var(--ksk-radius-popup);
  background: var(--ksk-surface);
  /* KSK063: popup colour slot (outline = ring, font = title, accent = close
     button); theme values otherwise. */
  box-shadow: var(--ksk-shadow-float), inset 0 0 0 2px var(--ksk-slot-outline, transparent);
  padding: var(--ksk-space-6);
  font-family: var(--ksk-font);
  color: var(--ksk-text);
}
.ksk-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ksk-space-3);
  margin-bottom: var(--ksk-space-4);
}
.ksk-modal__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--ksk-slot-font, var(--ksk-text));
}
.ksk-modal__close {
  position: relative;
  width: 72px;
  height: 72px;
  flex: none;
  margin: -12px -12px 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--ksk-slot-accent, var(--ksk-surface-muted));
  color: var(--ksk-text);
  overflow: hidden;
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.ksk-modal__close .material-icons-round {
  font-size: 36px;
}
.ksk-modal__close::after {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
}
.ksk-modal__close:active {
  transform: scale(0.97);
}
.ksk-modal__close:active::after {
  opacity: 0.08;
}
.ksk-modal__footer {
  display: flex;
  gap: var(--ksk-space-2);
  margin-top: var(--ksk-space-4);
}
.ksk-modal__footer > * {
  flex: 1;
}
</style>
